/**
 * Image floating element renderer (F-30/F-32) — registries/element-types/image
 * per docs/08 §2: one folder per element type; the canvas layer knows nothing
 * about specific types.
 */
import type { ElementInfo } from "@kola/shared";

import { assetUrl } from "../../../core/api.js";

export interface ElementRendererProps {
  element: ElementInfo;
}

export function ImageElementView({ element }: ElementRendererProps) {
  const payload = element.payload;
  if (payload.kind !== "image") return null;
  return (
    <img
      className="element-image"
      src={assetUrl(payload.assetId)}
      alt=""
      draggable={false}
      // Natural size lives in the payload; displayed size comes from the
      // element's own w/h keys (C2) — the wrapper sizes us, we just fill.
      width={payload.w}
      height={payload.h}
    />
  );
}
